"use strict";

class AuthRegisterCtrl {

    constructor($http, $sce, $timeout, $scope, vcRecaptchaService) {

        let csrftoken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        this.$http = $http;
        this.$sce = $sce;
        this.$scope = $scope;
        this.vcRecaptchaService = vcRecaptchaService;

        this.$timeout = $timeout;

        // Defaults
        this.formdata = {
            _token: csrftoken
        };

        this.status = {
            error: false,
            errorMessages: [],
            sending: false
        };
    }

    /**
     * [submit description]
     * @param  {Boolean} isValid [description]
     * @return {[type]}          [description]
     */
    submit(isValid) {

        if (!isValid) {

            return;
        }

        //this is for the station type hard coded because there is 1 option atm.
        this.formdata.station_type = 'music';

        this.status.sending = true;
        this.status.error = false;
        this.status.errorMessages.length = 0;
        console.log(this.formdata);
        if (this.formdata.password) {
            this.$http.post('/auth/register', this.formdata).then((response) => {
                if (response.data === 'exists') {
                    window.location = '/auth/register3';
                } else {
                    window.location = '/auth/register2';
                }
            }).catch((response) => {
                // Extract Laravel errors
                console.log(response);

                Object.getOwnPropertyNames(response.data).forEach((fieldName) => {

                    response.data[fieldName].forEach((message) => {

                        this.status.errorMessages.push(this.$sce.trustAsHtml(message));
                    });
                });

                this.status.error = true;
                this.status.sending = false;
                this.vcRecaptchaService.reload();

            });
        } else if (this.formdata.phone) {
            this.$http.post('/auth/register2', this.formdata)
                .then((response) => {
                    if (response.data.invited) {
                        window.location = '/login';
                    } else {
                        window.location = '/auth/register3';
                    }
                })
                .catch((response) => {
                    // Extract Laravel errors
                    Object.getOwnPropertyNames(response.data).forEach((fieldName) => {

                        response.data[fieldName].forEach((message) => {

                            this.status.errorMessages.push(this.$sce.trustAsHtml(message));
                        });
                    });

                    this.status.error = true;
                    this.status.sending = false;
                });
        } else {
            this.$http.post('/auth/register3', this.formdata)
                .then((response) => {
                    this.showProgress = true;
                    this.checkIfReady(response.data.id);
                })
                .catch((response) => {
                    // Extract Laravel errors
                    Object.getOwnPropertyNames(response.data).forEach((fieldName) => {

                        response.data[fieldName].forEach((message) => {

                            this.status.errorMessages.push(this.$sce.trustAsHtml(message));
                        });
                    });

                    this.status.error = true;
                    this.status.sending = false;
                });
        }
    }

    checkIfSystemNameExists(systemName) {
        if (!systemName) {
            systemName = this.formdata.system_name;
        }
        this.$http.get('/station/checksystemname/' + systemName).then(response => {
            if (response.data != true) {
                this.formdata.system_name = systemName;
                this.$scope.formRegister.system_name.$setValidity('unique', true);
            } else {
                this.$scope.formRegister.system_name.$setValidity('unique', false);
            }
        });
    }

    fillInSystemName() {
        if (!this.formdata.system_name && this.formdata.station_name) {
            let stripedStationName = this.formdata.station_name.trim().replace(/[^a-zA-Z0-9_]/g, '').toLowerCase();

            this.checkIfSystemNameExists(stripedStationName);
        }
    }

    sanitizeSystemName() {
        this.formdata.system_name = this.formdata.system_name.trim().replace(/[^a-zA-Z0-9_]/g, '').toLowerCase();
    }

    checkIfReady(station_id) {
        let loop = setInterval(() => {
            this.$http.get('/station/check/' + station_id).then(response => {
                if (response.data) {
                    console.log('db created');
                    clearInterval(loop);
                    window.location = response.data;
                }
            });

        }, 1000);

    }
}

AuthRegisterCtrl.$inject = ['$http', '$sce', '$timeout', '$scope', 'vcRecaptchaService'];

module.exports = AuthRegisterCtrl;
